function debugCookieExists() {
    return document.cookie.indexOf('debug=true') >= 0;
}

export const trace =
    // biome-ignore lint/suspicious/noExplicitAny: legacy
    import.meta.env.DEV || debugCookieExists() ? (...args: any) => console.log('[debug]', ...args) : () => {};
